module.exports = __webpack_public_path__ + "static/media/accessories.57698cc1.jpg";